// XXX propagate to rest of text components
const dimensions = {
  large: {
    horzMargin: '4px', // half (added to prev component's)
    vertMargin: '16px', // max with prev component (margin collapse)
    height: '36px', // many text components: buttons, inputs, form fields, not paragraph
    fontSize: '16px',
    lineHeight: '1.38',
  },
  medium: {
    horzMargin: '5px',
    vertMargin: '10px',
    height: '30px',
    fontSize: '14px',
    lineHeight: '1.29',
  },
  small: {
    horzMargin: '4px',
    vertMargin: '6px',
    height: '22px',
    fontSize: '12px',
    lineHeight: '1.33',
  },
  xsmall: {
    horzMargin: '4px', // speculative
    vertMargin: '4px', // speculative
    height: '16px', // speculative
    fontSize: '10px',
    lineHeight: '1.4',
    letterSpacing: '0.2px',
  },
}
dimensions.default = dimensions.medium

export default dimensions
